import { createSelector } from "reselect";
import { State } from "../../../state";
import {
  buildHighlightedCellMap,
  isCellHighlighted
} from "./highlightedCellMap";

export const getHighlightedCells = (state: State) => state.highlightedCells;

export const getHighlightedCellMap = createSelector(
  getHighlightedCells,
  buildHighlightedCellMap
);

export const getHighlightedCellFn = createSelector(
  getHighlightedCellMap,
  highlightedCellMap => isCellHighlighted(highlightedCellMap)
);



// WEBPACK FOOTER //
// ./src/spread/model/highlightedCells/selector.ts